import type { ISocialOfferWithFavoriteChallenges } from "@api";
import type { ISocialOffer } from "@bbj-types/offer";
import { useState } from "react";

export const useSocialOfferDetails = (offer: ISocialOfferWithFavoriteChallenges) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [innerOffer, setInnerOffer] = useState<ISocialOfferWithFavoriteChallenges>(offer);

  const setDrawerOffer = (offer: ISocialOffer | null) => {
    if (offer) {
      setIsDrawerOpen(true);
    } else {
      setIsDrawerOpen(false);
    }
  };

  return {
    setDrawerOffer,
    isDrawerOpen,
    isModalOpen,
    setIsModalOpen,
    innerOffer,
    setInnerOffer,
  };
};
